export default "__VITE_ASSET__409c4fbb__"